// extracted by mini-css-extract-plugin
module.exports = {"intro":"blog-module--intro--nTHoD","post":"blog-module--post--22Szq"};